{
  "TargetreportformatLabel": "Formato del rapporto target:",
  "TargetreportformatPdfOptionLabel": "Documento PDF",
  "TargetreportformatRtfOptionLabel": "Documento RTF",
  "TargetreportformatCsvOptionLabel": "Esportazione CSV",
  "UselanguageLabel": "Utilizzare la lingua:",
  "UselanguageEnusOptionLabel": "Inglese (Stati Uniti)",
  "UselanguageEngbOptionLabel": "Inglese (Regno Unito)",
  "PapersizeLabel": "Formato carta:",
  "PapersizeA4OptionLabel": "A4 (210 mm x 297 mm)",
  "PapersizeLegalOptionLabel": "Legale (8½\" x 14\")",
  "PapersizeLetterOptionLabel": "Lettera (8½\" x 11\")",
  "Format_SectionHeader": "Formato",
  "NAME": "Format",
  "TargetreportformatXlsOptionLabel": "Esportazione XLS"
}